@if (items$ | async; as items) {
  @if ((disabled$ | async) === false) {
    <mat-checkbox
      #checkbox="matCheckbox"
      class="checkbox"
      color="primary"
      [ngClass]="{ disabled: isCheckboxDisabled$ | async }"
      [disabled]="isCheckboxDisabled$ | async"
      [checked]="isSelected$ | async"
      (change)="setSelected(items, checkbox.checked)"
    />
  }
}
